import React from 'react';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { FormControlLabel, Switch } from '@mui/material';
import { ReadOnlyStatusIndicator } from './readonly-status-indicator';

interface ConditionalStatusIndicatorProps<T extends FieldValues> {
  name: Path<T>;
  control: Control<T>;
  isReadOnly: boolean;
  activeText?: string;
  inactiveText?: string;
}

const StatusIndicator = <T extends FieldValues>({
  name,
  control,
  isReadOnly,
  activeText = 'Active',
  inactiveText = 'Inactive',
}: ConditionalStatusIndicatorProps<T>): React.ReactElement => {
  if (isReadOnly) {
    return (
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <ReadOnlyStatusIndicator
            value={field.value}
            activeText={activeText}
            inactiveText={inactiveText}
          />
        )}
      />
    );
  }

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <FormControlLabel
          control={
            <Switch checked={value} onChange={e => onChange(e.target.checked)} color="primary" />
          }
          label={value ? activeText : inactiveText}
        />
      )}
    />
  );
};

export default StatusIndicator;
